import "./About.scss"
import React from "react"
import { config } from "../../../config"
import { useTranslation, Trans } from "react-i18next"

const feedback = {
  correct: "Your answer is correct, good job!",
  incorrect: "Your answer is incorrect, try again!",
}

const Feedback = ({ status, className = "" }) => {
  switch (status) {
    case "submittedCorrectAnswer":
      return (
        <div className={`alert alert-success ${className}`} role="alert">
          {feedback.correct}
        </div>
      )
    case "submittedIncorrectAnswer":
      return (
        <div className={`alert alert-warning ${className}`} role="alert">
          {feedback.incorrect}
        </div>
      )
    default:
      return null
  }
}

const initialState = {
  status: "waitingAnswer", // "waitingAnswer" | "submittedIncorrectAnswer" | "submittedCorrectAnswer"
  currentQuestion: 0,
  selectedAnswer: null,
}

const WordImageMatching = (props) => {
  const [state, setState] = React.useState(initialState)

  const question = props.gameConfig.questions[state.currentQuestion]

  const handleSubmit = (event) => {
    event.preventDefault()
    const checked =
      event.currentTarget.elements[question.correct_answer.word].checked
    if (checked) {
      if (state.currentQuestion < props.gameConfig.questions.length - 1) {
        setState({
          status: "waitingAnswer",
          currentQuestion: state.currentQuestion + 1,
          selectedAnswer: null,
        })
      } else {
        props.onCompleted()
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        status: checked ? "submittedCorrectAnswer" : "submittedIncorrectAnswer",
      }))
    }
  }

  const correctAnswersSoFar =
    state.status === "submittedCorrectAnswer"
      ? state.currentQuestion + 1
      : state.currentQuestion

  const progressPercentage =
    (correctAnswersSoFar / props.gameConfig.questions.length) * 100

  const { t } = useTranslation()

  return (
    <div
      className="word-image-matching d-flex flex-grow-1"
      style={{ zIndex: 1 }}
    >
      <form
        className="d-flex flex-column p-3 bg-light text-body  flex-grow-1 shadow"
        onSubmit={handleSubmit}
        style={{
          borderRadius: 15,
        }}
      >
        {props.gameConfig.type === "with_starting_letter" ? (
          <p>
            <Trans
              i18nKey="about.easter.find_letter"
              values={{ l: props.letter }}
              components={{ bold: <strong /> }}
            />
          </p>
        ) : (
          <p>{t(`about.easter.title`)}</p>
        )}
        <p>{t(`about.easter.question`)}</p>
        <div className="d-flex gap-4 mb-3">
          <img
            src={`${config.imgUrl}/words/${question.correct_answer.imageUrl}`}
            alt=""
            style={{
              width: 80,
            }}
          />
          <div className="d-flex justify-content-center w-100">
            <div className="d-flex gap-3">
              {question.options.map((option) => (
                <React.Fragment key={option}>
                  <input
                    type="radio"
                    className="btn-check"
                    name="options"
                    id={option}
                    autoComplete="off"
                    checked={state.selectedAnswer === option}
                    onChange={() => {
                      setState((prevState) => ({
                        ...prevState,
                        selectedAnswer: option,
                      }))
                    }}
                    disabled={state.status === "submittedCorrectAnswer"}
                  />
                  <label className="btn btn-outline-success" htmlFor={option}>
                    {option}
                  </label>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div
            className="d-flex flex-column align-items-center"
            style={{ width: 100 }}
          >
            <div className="progress w-100 align-self-center">
              <div
                className="progress-bar progress-bar-striped bg-success"
                style={{
                  width: `${progressPercentage}%`,
                }}
                role="progressbar"
                aria-valuenow={progressPercentage}
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            {correctAnswersSoFar} / {props.gameConfig.questions.length}
          </div>
          <div className="d-flex gap-2">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={props.onCancel}
            >
              {t(`ui.btns.cancel`)}
            </button>
            <button
              className="btn btn-primary"
              style={{ alignSelf: "flex-end" }}
              type="submit"
              disabled={
                state.status === "waitingAnswer" && state.selectedAnswer == null
              }
            >
              {state.status === "submittedCorrectAnswer"
                ? state.currentQuestion ===
                  props.gameConfig.questions.length - 1
                  ? t(`ui.btns.finish`)
                  : t(`ui.btns.next`)
                : t(`ui.btns.submit`)}
            </button>
          </div>
        </div>
        <Feedback status={state.status} className="mt-3" />
      </form>
    </div>
  )
}

export default WordImageMatching
